import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f1d29ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_2 = { class: "empty-state-message" }




export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    message: {
        type: String,
        default: "No data available."
    },
    showEmptyState: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.showEmptyState)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.message), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})